import { Loader } from '@mantine/core';
import clsx from 'clsx';
import { useGate, useUnit } from 'effector-react';
import { ComponentPropsWithoutRef, forwardRef } from 'react';
import { Row, RegistryModel } from 'shared/lib';

export type RegistryRootProps = ComponentPropsWithoutRef<'div'>;

export const createRegistryRoot = <
	TRow extends Row,
	TFilters extends Record<string, unknown>,
	TError,
>(
	model: RegistryModel<TRow, TFilters, TError>,
) => {
	const RegistryRoot = forwardRef<HTMLDivElement, RegistryRootProps>(
		({ children, className, ...props }, ref) => {
			useGate(model.gate);

			const initialized = useUnit(model.$initialized);

			return (
				<div
					ref={ref}
					className={clsx('registry-root', className)}
					{...props}
				>
					{initialized ? children : <Loader />}
				</div>
			);
		},
	);

	return RegistryRoot;
};
